module.exports = __webpack_public_path__ + "3d3dbf447928be0d988046dbd77b1874.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-16.jpg
// module id = 1156
// module chunks = 0